export var baseTypography = {
    height: {
        Small: '100%',
        Medium: '140%',
        Large: '170%',
        SmallMultiplier: 1,
        MediumMultiplier: 1.4,
        LargeMultiplier: 1.7,
    },
    size: {
        '100': {
            pixels: 10,
            px: '10px',
            rem: '0.625rem',
        },
        '200': {
            pixels: 12,
            px: '12px',
            rem: '0.75rem',
        },
        '300': {
            pixels: 14,
            px: '14px',
            rem: '0.875rem',
        },
        '400': {
            pixels: 16,
            px: '16px',
            rem: '1rem',
        },
        '450': {
            pixels: 18,
            px: '18px',
            rem: '1.125rem',
        },
        '500': {
            pixels: 20,
            px: '20px',
            rem: '1.25rem',
        },
        '550': {
            pixels: 24,
            px: '24px',
            rem: '1.5rem',
        },
        '600': {
            pixels: 28,
            px: '28px',
            rem: '1.75rem',
        },
        '700': {
            pixels: 32,
            px: '32px',
            rem: '2rem',
        },
        '800': {
            pixels: 36,
            px: '36px',
            rem: '2.25rem',
        },
        '850': {
            pixels: 40,
            px: '40px',
            rem: '2.5rem',
        },
        '900': {
            pixels: 48,
            px: '48px',
            rem: '3rem',
        },
        '1000': {
            pixels: 56,
            px: '56px',
            rem: '3.5rem',
        },
        '1100': {
            pixels: 64,
            px: '64px',
            rem: '4rem',
        },
        icon: {
            '50': {
                pixels: 12,
                px: '12px',
                rem: '0.75rem',
            },
            '100': {
                pixels: 16,
                px: '16px',
                rem: '1rem',
            },
            '200': {
                pixels: 20,
                px: '20px',
                rem: '1.25rem',
            },
            '300': {
                pixels: 24,
                px: '24px',
                rem: '1.5rem',
            },
            '400': {
                pixels: 28,
                px: '28px',
                rem: '1.75rem',
            },
            '500': {
                pixels: 32,
                px: '32px',
                rem: '2rem',
            },
            '600': {
                pixels: 40,
                px: '40px',
                rem: '2.5rem',
            },
            '900': {
                pixels: 64,
                px: '64px',
                rem: '4rem',
            },
        },
    },
    weight: {
        Regular: 400,
        Medium: 500,
        Bold: 700,
    },
};
export var textStyle100BoldHeightL = {
    fontSize: '0.625rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle100BoldHeightM = {
    fontSize: '0.625rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle100BoldHeightS = {
    fontSize: '0.625rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle100MediumHeightL = {
    fontSize: '0.625rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle100MediumHeightM = {
    fontSize: '0.625rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle100MediumHeightS = {
    fontSize: '0.625rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle100RegularHeightL = {
    fontSize: '0.625rem',
    lineHeight: '170%',
};
export var textStyle100RegularHeightM = {
    fontSize: '0.625rem',
    lineHeight: '140%',
};
export var textStyle100RegularHeightS = {
    fontSize: '0.625rem',
    lineHeight: '100%',
};
export var textStyle200BoldHeightL = {
    fontSize: '0.75rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle200BoldHeightLUppercase = {
    fontSize: '0.75rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
    textTransform: 'uppercase',
};
export var textStyle200BoldHeightM = {
    fontSize: '0.75rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle200BoldHeightS = {
    fontSize: '0.75rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle200MediumHeightL = {
    fontSize: '0.75rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle200MediumHeightM = {
    fontSize: '0.75rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle200MediumHeightS = {
    fontSize: '0.75rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle200MediumHeightSUppercase = {
    fontSize: '0.75rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
    textTransform: 'uppercase',
};
export var textStyle200RegularHeightL = {
    fontSize: '0.75rem',
    lineHeight: '170%',
};
export var textStyle200RegularHeightM = {
    fontSize: '0.75rem',
    lineHeight: '140%',
};
export var textStyle200RegularHeightS = {
    fontSize: '0.75rem',
    lineHeight: '100%',
};
export var textStyle200RegularHeightSUppercase = {
    fontSize: '0.75rem',
    lineHeight: '100%',
    textTransform: 'uppercase',
};
export var textStyle300BoldHeightL = {
    fontSize: '0.875rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle300BoldHeightM = {
    fontSize: '0.875rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle300BoldHeightS = {
    fontSize: '0.875rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle300BoldHeightSUppercase = {
    fontSize: '0.875rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
    textTransform: 'uppercase',
};
export var textStyle300MediumHeightL = {
    fontSize: '0.875rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle300MediumHeightM = {
    fontSize: '0.875rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle300MediumHeightS = {
    fontSize: '0.875rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle300MediumHeightSUppercase = {
    fontSize: '0.875rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
    textTransform: 'uppercase',
};
export var textStyle300RegularHeightL = {
    fontSize: '0.875rem',
    lineHeight: '170%',
};
export var textStyle300RegularHeightM = {
    fontSize: '0.875rem',
    lineHeight: '140%',
};
export var textStyle300RegularHeightS = {
    fontSize: '0.875rem',
    lineHeight: '100%',
};
export var textStyle300RegularHeightSUppercase = {
    fontSize: '0.875rem',
    lineHeight: '100%',
    textTransform: 'uppercase',
};
export var textStyle400BoldHeightL = {
    fontSize: '1rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle400BoldHeightM = {
    fontSize: '1rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle400BoldHeightS = {
    fontSize: '1rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle400MediumHeightL = {
    fontSize: '1rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle400MediumHeightM = {
    fontSize: '1rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle400MediumHeightMUppercase = {
    fontSize: '1rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
    textTransform: 'uppercase',
};
export var textStyle400MediumHeightS = {
    fontSize: '1rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle400RegularHeightL = {
    fontSize: '1rem',
    lineHeight: '170%',
};
export var textStyle400RegularHeightM = {
    fontSize: '1rem',
    lineHeight: '140%',
};
export var textStyle400RegularHeightS = {
    fontSize: '1rem',
    lineHeight: '100%',
};
export var textStyle450BoldHeightL = {
    fontSize: '1.125rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle450BoldHeightM = {
    fontSize: '1.125rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle450BoldHeightS = {
    fontSize: '1.125rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle450MediumHeightL = {
    fontSize: '1.125rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle450MediumHeightM = {
    fontSize: '1.125rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle450MediumHeightS = {
    fontSize: '1.125rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle450RegularHeightL = {
    fontSize: '1.125rem',
    lineHeight: '170%',
};
export var textStyle450RegularHeightM = {
    fontSize: '1.125rem',
    lineHeight: '140%',
};
export var textStyle450RegularHeightS = {
    fontSize: '1.125rem',
    lineHeight: '100%',
};
export var textStyle500BoldHeightL = {
    fontSize: '1.25rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle500BoldHeightM = {
    fontSize: '1.25rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle500BoldHeightS = {
    fontSize: '1.25rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle500MediumHeightL = {
    fontSize: '1.25rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle500MediumHeightM = {
    fontSize: '1.25rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle500MediumHeightS = {
    fontSize: '1.25rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle500RegularHeightL = {
    fontSize: '1.25rem',
    lineHeight: '170%',
};
export var textStyle500RegularHeightM = {
    fontSize: '1.25rem',
    lineHeight: '140%',
};
export var textStyle500RegularHeightS = {
    fontSize: '1.25rem',
    lineHeight: '100%',
};
export var textStyle600BoldHeightL = {
    fontSize: '1.75rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle600BoldHeightM = {
    fontSize: '1.75rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle600BoldHeightS = {
    fontSize: '1.75rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle600MediumHeightL = {
    fontSize: '1.75rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle600MediumHeightM = {
    fontSize: '1.75rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle600MediumHeightS = {
    fontSize: '1.75rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle600RegularHeightL = {
    fontSize: '1.75rem',
    lineHeight: '170%',
};
export var textStyle600RegularHeightM = {
    fontSize: '1.75rem',
    lineHeight: '140%',
};
export var textStyle600RegularHeightS = {
    fontSize: '1.75rem',
    lineHeight: '100%',
};
export var textStyle700BoldHeightL = {
    fontSize: '2rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle700BoldHeightM = {
    fontSize: '2rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle700BoldHeightS = {
    fontSize: '2rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle700MediumHeightL = {
    fontSize: '2rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle700MediumHeightM = {
    fontSize: '2rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle700MediumHeightS = {
    fontSize: '2rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle700RegularHeightL = {
    fontSize: '2rem',
    lineHeight: '170%',
};
export var textStyle700RegularHeightM = {
    fontSize: '2rem',
    lineHeight: '140%',
};
export var textStyle700RegularHeightS = {
    fontSize: '2rem',
    lineHeight: '100%',
};
export var textStyle800BoldHeightL = {
    fontSize: '2.25rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle800BoldHeightM = {
    fontSize: '2.25rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle800BoldHeightS = {
    fontSize: '2.25rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle800MediumHeightL = {
    fontSize: '2.25rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle800MediumHeightM = {
    fontSize: '2.25rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle800MediumHeightS = {
    fontSize: '2.25rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle800RegularHeightL = {
    fontSize: '2.25rem',
    lineHeight: '170%',
};
export var textStyle800RegularHeightM = {
    fontSize: '2.25rem',
    lineHeight: '140%',
};
export var textStyle800RegularHeightS = {
    fontSize: '2.25rem',
    lineHeight: '100%',
};
export var textStyle850BoldHeightL = {
    fontSize: '2.5rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle850BoldHeightM = {
    fontSize: '2.5rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle850BoldHeightS = {
    fontSize: '2.5rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle850MediumHeightL = {
    fontSize: '2.5rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle850MediumHeightM = {
    fontSize: '2.5rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle850MediumHeightS = {
    fontSize: '2.5rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle850RegularHeightL = {
    fontSize: '2.5rem',
    lineHeight: '170%',
};
export var textStyle850RegularHeightM = {
    fontSize: '2.5rem',
    lineHeight: '140%',
};
export var textStyle850RegularHeightS = {
    fontSize: '2.5rem',
    lineHeight: '100%',
};
export var textStyle900BoldHeightL = {
    fontSize: '3rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle900BoldHeightM = {
    fontSize: '3rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle900BoldHeightS = {
    fontSize: '3rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle900MediumHeightL = {
    fontSize: '3rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle900MediumHeightM = {
    fontSize: '3rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle900MediumHeightS = {
    fontSize: '3rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle900RegularHeightL = {
    fontSize: '3rem',
    lineHeight: '170%',
};
export var textStyle900RegularHeightM = {
    fontSize: '3rem',
    lineHeight: '140%',
};
export var textStyle900RegularHeightS = {
    fontSize: '3rem',
    lineHeight: '100%',
};
export var textStyle1000BoldHeightL = {
    fontSize: '3.5rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle1000BoldHeightM = {
    fontSize: '3.5rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle1000BoldHeightS = {
    fontSize: '3.5rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle1000MediumHeightL = {
    fontSize: '3.5rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle1000MediumHeightM = {
    fontSize: '3.5rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle1000MediumHeightS = {
    fontSize: '3.5rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle1000RegularHeightL = {
    fontSize: '3.5rem',
    lineHeight: '170%',
};
export var textStyle1000RegularHeightM = {
    fontSize: '3.5rem',
    lineHeight: '140%',
};
export var textStyle1000RegularHeightS = {
    fontSize: '3.5rem',
    lineHeight: '100%',
};
export var textStyle1100BoldHeightL = {
    fontSize: '4rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle1100BoldHeightM = {
    fontSize: '4rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle1100BoldHeightS = {
    fontSize: '4rem',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle1100MediumHeightL = {
    fontSize: '4rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '170%',
};
export var textStyle1100MediumHeightM = {
    fontSize: '4rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '140%',
};
export var textStyle1100MediumHeightS = {
    fontSize: '4rem',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '100%',
};
export var textStyle1100RegularHeightL = {
    fontSize: '4rem',
    lineHeight: '170%',
};
export var textStyle1100RegularHeightM = {
    fontSize: '4rem',
    lineHeight: '140%',
};
export var textStyle1100RegularHeightS = {
    fontSize: '4rem',
    lineHeight: '100%',
};
